"use client";

// Eingeklappte Leiste — wie `useUIStore` im Agent, aber ohne zustand:
// ein Wert in localStorage, geteilt ueber useSyncExternalStore, damit
// Leiste und Kopfzeile denselben Stand sehen.
import { useCallback, useSyncExternalStore } from "react";

const KEY = "clubhub-leiste-eingeklappt";
const hoerer = new Set<() => void>();

function lesen(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

function abonnieren(fn: () => void) {
  hoerer.add(fn);
  const beiSpeicher = (e: StorageEvent) => e.key === KEY && fn();
  window.addEventListener("storage", beiSpeicher);
  return () => {
    hoerer.delete(fn);
    window.removeEventListener("storage", beiSpeicher);
  };
}

export function useLeiste() {
  const eingeklappt = useSyncExternalStore(abonnieren, lesen, () => false);
  const umschalten = useCallback(() => {
    try {
      localStorage.setItem(KEY, lesen() ? "0" : "1");
    } catch {}
    hoerer.forEach((fn) => fn());
  }, []);
  return { eingeklappt, umschalten };
}
